<template>
  <div class="container-fluid ">
    <div class="about" style="padding-top: 15px;">
        <h4>このアプリについて</h4>
          過去のNPB球団の成績の相関図を生成するwebアプリです。特定の成績同士の相関関係を計算します。<br>
          このアプリを使用したことによって生じたすべての障害・損害・不具合等に関しては、一切の責任を負いません。<br>
          <br>
        <h4>使い方</h4>
        x軸・y軸にそれぞれ成績を設定します。<br>
        x-y交換を押すとx軸・y軸の入力内容を入れ替え、対象範囲を変更すると対象年度の絞り込み範囲が変わります。<br>
        y軸の方はx軸からの年数を設定できます。例えば、x軸から「1年後」でx軸・y軸ともに「打率」を選択すると、各年のチーム打率とその球団の翌年のチーム打率の相関関係を求められます。<br><br>
        詳細から「試合ごと」にチェックを入れると試合数で割った数字に、「傑出度」にチェックを入れるとその年のリーグ平均を100とした相対的な数字になります。<br>
    </div>
  </div>
</template>
<script>

export default {
  name: 'about'
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

h4 {
  position: relative;
  padding: 5px 5px 5px 42px;
  background: #fcac9a;
  font-size: 20px;
  color: white;
  margin-left: -33px;
  line-height: 1.3;
  z-index:-1;
}

h4:before {
  position: absolute;
  content: '';
  left: -2px;
  top: -2px;
  border: none;
  border-left: solid 40px white;
  border-bottom: solid 79px transparent;
  z-index:-2
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/about.vue